import "./MultiBattleVideoGeneratorDialog.scss";
import NP, {EventArgs, IHash} from "../1. Core/NP";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import {ServerAPI} from "../1. Core/ServerAPI";
import {EventTournament, FunnyItem, HighlightRow, IAthlete, IBattle, VideoFile} from "../10. Battle/types";

import Select from "../1. Core/Controls/Select/Select";
import {MAIN_SERVER_URL} from "./types";
import Button from "../1. Core/Controls/Button/Button";
import Dialog, {DialogCloseEventArgs} from "../1. Core/Controls/Dialog/Dialog";
import Label from "../1. Core/Controls/Label/Label";
import MenuButton from "../1. Core/Controls/MenuButton/MenuButton";
import {getViewName, secondsToTime} from "../10. Battle/Util";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import TextField from "../1. Core/Controls/TextField/TextField";
import {createFunnyRow, getBattleMenuItems, getPointTimeFromWT, showSegmentMenu, showShareDialog} from "./func";
import {IItem} from "../1. Core/Controls/ListBox/ListItem";
import Delegate from "../1. Core/Delegate";
import Menu, {MenuItemArgs} from "../1. Core/Controls/Menu/Menu";
import SelectEventDialog from "./SelectEventDialog";

let moment = require('moment');

export default class MultiBattleVideoGeneratorDialog extends Dialog {

	private _Battles: IBattle[];
	private _AllBattles: IBattle[];

	private _dataTable: DataTable;
	private _allActionList: HighlightRow[];

	private _GridHeight: number;


	private _videoPreviewType: Select;


	private _rightNode: HTMLElement;

	private _videoNode: HTMLVideoElement;


	private _leftNode: HTMLElement;
	private menuBtn: MenuButton;
	private _Event: EventTournament;
	private _Athlete: IAthlete;

	private timeId: any;
	private actionTypeBtn: MenuButton;
	private zoneFilterBtn: MenuButton;

	private actionsByBattle: IHash<HighlightRow[]>
	private fynnyActionsByBattle: IHash<FunnyItem[]>
	private pointFilterBtn: MenuButton;
	private answerFilterBtn: MenuButton;
	private startStreamDate: Date;
	private _streamTimeId: any;
	private _timerLbl: Label;
	private _progressLabel: Label;
	private otherFilterBtn: MenuButton;
	private _videoProgressBar: HTMLElement;
	private _ViewBattle: IBattle;
	private previewSettingsBtn: MenuButton;
	private _orderEventList: DataTable;
	private _orderList: HighlightRow[];
	private _AllTournEvents: EventTournament[];


	constructor(settings: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this._Athlete = null;
		this._Event = null;
		this._Battles = [];
		this._GridHeight = 500;
		super._initFields(settings);
		this._Caption = this._Event ? this._Event.Name : getViewName(this._Athlete);
		this._ShowHeader = true;
		this._Mode = 'FullScreen';
		this._ShowButtons = false
	}

	_render()
	{
		super._render();
		this.addClass('battle-video-generator')

		this._okButton.setRK('StartCreateVideo');
		NP.addCssClass(this._contentDomNode, 'dialog__surface--fullscreen');
		NP.addCssClass(this._container, 'dialog__container--fullscreen');

		this.getTopAppBar().addItem(this._timerLbl = new Label() as any, this._okButton);
		this._timerLbl.getRoot().style.color = 'black';
		this.getTopAppBar().addItem(this._progressLabel = new Label() as any, this._okButton);
		this._progressLabel.getRoot().style.color = 'black';


		this._contentNode.style.overflow = 'hidden'

		this._orderList = []

		let settingNode = NP.createNode(this._contentNode, 'multi-battle-video-setting')

		this._AllTournEvents = []

		if (this._Event)
			this._AllTournEvents.push(this._Event)

		this.menuBtn = new MenuButton({
			ParentNode: settingNode,
			Text: NP.RM.getString('ManageBattleList'),
			EvChanged: () =>
			{
				this._Battles = this.menuBtn.getMenu().getSelectedValues();
				this.refreshDataTable()
			},
			EvItemClicked: (s: object, e: MenuItemArgs) =>
			{
				if (e.Item.getValue() == 'AddEvent')
				{
					(new SelectEventDialog({
						SportType: this._AllBattles[0].Type,
						EvOkButtonClick: (s: object, e: { Event: EventTournament }) =>
						{
							if (e.Event)
							{
								this._AllTournEvents.push(e.Event)
								this.refresh()
							}
						}
					})).show()
				}
			}
		})

		this.actionTypeBtn = new MenuButton({
			ParentNode: settingNode,
			Text: 'Actions',
			Items: [
				{Content: 'Takedown', Value: 'Takedown'},
				{Content: 'Transition', Value: 'Transition'},
				{Content: 'Submission', Value: 'Submission'},
				{Content: 'Kick', Value: 'Kick'},
				{Content: 'Knee', Value: 'Knee'},
				{Content: 'Elbow', Value: 'Elbow'},
				{Content: 'Punch', Value: 'Punch'},
				{Content: 'Control', Value: 'Control'},
			],
			EvChanged: () => this.refreshDataTable()
		})
		this.actionTypeBtn.setValue(['Takedown'])


		this.zoneFilterBtn = new MenuButton({
			ParentNode: settingNode,
			Text: 'Zone',
			Items: [
				{Content: 'P1', Value: 'P1'},
				{Content: 'P2', Value: 'P2'},
				{Content: 'P3', Value: 'P3'},
				{Content: 'P4', Value: 'P4'},
				{Content: 'P5', Value: 'P5'},
				{Content: 'P6', Value: 'P6'},
			],
			EvChanged: () => this.refreshDataTable()
		})
		this.zoneFilterBtn.setValue(['P1', 'P2', 'P3', 'P4', 'P5', 'P6'])


		this.pointFilterBtn = new MenuButton({
			ParentNode: settingNode,
			Text: 'Points',
			Items: [
				{Content: 'Bad', Value: 'Bad'},
				{Content: 'Poor', Value: 'Poor'},
				{Content: 'Good', Value: 'Good'},
				{Content: '3.5', Value: 3.5},
				{Content: '4', Value: 4}
			],
			EvChanged: () => this.refreshDataTable()
		})
		this.pointFilterBtn.setValue([3.5, 4])


		this.answerFilterBtn = new MenuButton({
			ParentNode: settingNode,
			Text: 'Result',
			Items: [
				{Content: 'Hit', Value: 'Hit'},
				{Content: 'Miss', Value: 'Miss'},
				{Content: 'Slip', Value: 'Slip'},
				{Content: 'Footwork', Value: 'Footwork'},
				{Content: 'Block', Value: 'Block'},
				{Content: 'Bobbing', Value: 'Bobbing'},
				{Content: 'Knockdown', Value: 'Knockdown'},
				{Content: 'CriticalPunch', Value: 'CriticalPunch'}
			],
			EvChanged: () => this.refreshDataTable()
		})
		this.answerFilterBtn.setValue(['Hit', 'Miss', 'Slip', 'Footwork', 'Block', 'Knockdown', 'CriticalPunch', 'Bobbing'])


		this.otherFilterBtn = new MenuButton({
			ParentNode: settingNode,
			Text: 'Other',
			Value: [],
			Items: [
				{Content: 'Нарезанные отрезки', Value: 'СutSegments'},
				{Content: 'Only Super', Value: 'Super'},
				{Content: 'Other Funny', Value: 'OtherFunny'},
				{Content: 'Only Favorite', Value: 'Favorite'},
				{Content: 'Grapple', Value: 'Grapple'},
				{Content: 'Ground', Value: 'Ground'},
			],
			EvChanged: () => this.refreshDataTable()
		})


		this._videoPreviewType = new Select({
			ParentNode: settingNode,
			Class: 'video-type-select',
			Width: 200
		})


		this.previewSettingsBtn = new MenuButton({
			ParentNode: settingNode,
			Text: 'Wallpaper',
			Value: [],
			Items: [
				{Content: 'Add first preview', Value: 1},
				{Content: 'Add preview to end', Value: 2}
			],
			EvChanged: () => this.refreshDataTable()
		})

		this.previewSettingsBtn.setValue([1, 2])


		let flexContentNode = NP.createNode(this._contentNode, 'multi-battle-video-generator-content')
		this._leftNode = NP.createNode(flexContentNode)
		this._rightNode = NP.createNode(flexContentNode, 'parent-video-node')


		this._dataTable = new DataTable({
			ShowSettingsButton: false,
			CustomSettingsButton: [{
				FontImage: NP.FontImages.arrow_right,
				ToolTip: NP.RM.getString('ShowOnVideo'),
				EvClick: (btn: Button) =>
				{
					this.viewEvent(btn.getData())
				}
			}],
			CustomSettingsButtonCreated: (ctrl: IconToggleButton) =>
			{
				let row = ctrl.getData();
				if (row?.MMAEvent?.SegmentFileName)
					ctrl.getRoot().style.color = "#00c77e"
			},
			ParentNode: this._leftNode,
			EnableSort: false,
			Height: this._GridHeight,
			Width: 900,
			HeaderPaddingRight: '107px',
			MultiSelect: true,
			EvSelectionChanged: () =>
			{
				this.refreshVideoProgressBar()
			},
			IsRowSelected: (row: any) => true,
			Columns: [{
				Content: 'R',
				PropertyContent: 'Round',
				Width: '30px'
			}, {
				Content: 'Action',
				PropertyContent: 'Action',
				Width: '77px'
			}, {
				Content: 'Z',
				PropertyContent: 'Zone',
				Width: '30px'
			}, {
				Content: 'Answer',
				PropertyContent: 'Answer',
				Width: '110px'
			}, {
				Content: 'Time',
				PropertyContent: 'Time',
				Width: '90px'
			}, {
				Content: 'World Time',
				PropertyContent: 'WorldTimeStr',
				Width: '90px'
			}, {
				Content: 'Desc',
				PropertyContent: 'HLDesc',
				Width: '170px'
			}, {
				Content: 'Position',
				PropertyContent: 'Position',
				Width: '100px'
			}, {
				Content: '-Prev+Next',
				PropertyContent: 'PrevNext',
				Width: '100px'
			}, {
				Content: 'Point',
				PropertyContent: 'Point',
				Width: '80px'
			}],
			EvItemContextMenu: (s: object, e: {
				Item: { MMAEvent: HighlightRow, FunnyEvent: FunnyItem },
				Node: HTMLElement
			}) =>
			{
				let ev = e.Item.MMAEvent || e.Item.FunnyEvent;
				this.showSegmentMenu(ev, e.Node)
			}
		});

		//-------------------------------------------------------------


		this._videoNode = NP.createNode(this._rightNode, '', 'video')
		this._videoNode.setAttribute('controls', 'true')
		this._videoNode.addEventListener('loadeddata', (event) =>
		{
			this.refreshVideoProgressBar()
		})

		this._videoProgressBar = NP.createNode(this._rightNode, 'video-progress-bar');


		let orderMenu = new Menu({
			Items: [{
				RK: 'ShowOnVideo',
				EvClick: () =>
				{
					let row = orderMenu.getParent().getData()
					this.viewEvent(row)
				}
			}, {
				Content: 'Insert  transition',
				EvClick: async () =>
				{
					let row = orderMenu.getParent().getData()

					let transItems = await ServerAPI.get<string[]>(`/video/getTransitions`, false);

					(new Dialog({
						Caption: 'Select transition',
						ShowHeader: true,
						Content: new Select({
							Items: transItems.map(t => ({Content: t, Value: t}))
						}),
						EvOkButtonClick: async (dlg: Dialog) =>
						{
							let t = dlg.getContent().getValue();
							if (t)
								this._orderEventList.addRowAfter({
									BattleName: t,
									Transition: t
								}, row)
						}
					})).show()
				}
			}, {
				RK: 'Delete',
				EvClick: () =>
				{
					let row = orderMenu.getParent().getData()
					this._orderEventList.removeRow(row)
				}
			}]
		})

		this._orderEventList = new DataTable({
			ParentNode: this._rightNode,
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			CanDragRows: true,
			EnableSort: false,
			EvItemContextMenu: (s: object, e: {
				Item: { MMAEvent: HighlightRow },
				Node: HTMLElement
			}) =>
			{
				let ev = e.Item.MMAEvent;
				this.showSegmentMenu(ev, e.Node)
			},
			CustomSettingsButton: [{
				FontImage: NP.FontImages.more_vert,
				Menu: orderMenu
			}],
			Columns: [{
				Content: 'Battle',
				PropertyContent: 'BattleName',
				Width: '100px'
			}, {
				Content: 'Action',
				PropertyContent: 'Action',
				Width: '77px'
			}, {
				Content: 'Answer',
				PropertyContent: 'Answer',
				Width: '110px'
			}, {
				Content: 'World Time',
				PropertyContent: 'WorldTimeStr',
				Width: '90px'
			}, {
				Content: 'Desc',
				PropertyContent: 'HLDesc',
				Width: '170px'
			}, {
				Content: '-Prev+Next',
				PropertyContent: 'PrevNext',
				Width: '100px'
			}, {
				Content: 'Point',
				PropertyContent: 'Point',
				Width: '80px'
			}],
			EvRowMoved: (o: object, args: { Row: any, Index: number }) =>
			{
				this._orderEventList.moveRow(args.Row, args.Index)
			}
		})
	}


	showSegmentMenu(ev: HighlightRow | FunnyItem, node: HTMLElement)
	{
		if (ev)
		{
			let battle = this._Battles.find(b => b.Id == ev.BattleId);
			let v = `${MAIN_SERVER_URL}/video/battle_${ev.BattleId}.mp4`;
			if (v != this._videoNode.src)
			{
				this._videoNode.src = v;
				this._ViewBattle = battle
			}
			showSegmentMenu(ev, this._videoNode, node, this._dataTable, battle.VideoStartTime, this.createRow.bind(this),
				 null,
				 new Delegate(this.onOrderListAdded, this),
				 new Delegate(this.evRowChanged, this))
		}
	}

	evRowChanged(battleEvent: HighlightRow)
	{
		let row = this._orderEventList.getRows().find((it: any) =>
		{
			if (it.MMAEvent)
				return it.EventOrder == (battleEvent as HighlightRow).EventOrder
			return false
		})

		if (row)
		{
			let newRow = this.createRow(battleEvent as HighlightRow)

			for (let key in row)
				row[key] = newRow[key]

			this._orderEventList.updateRow(row)
		}
	}

	onOrderListAdded(s: object, e: { Item: HighlightRow })
	{
		if (this._orderEventList.getRows().find((row: any) => row.MMAEvent == e.Item) == null)
		{
			let row = this.createRow(e.Item)
			this._orderEventList.addRow(row)
		}
	}

	show()
	{
		super.show();
		this.refresh();
		this.setHeight(this._Height)
	}

	async refresh()
	{
		this._topAppBar.showWaiter()
		try
		{
			let filter = {
				"Offset": 0,
				"Count": 100,
				AthleteId: null,
				EventId: null,
				"SortField": "StartTime",
				"SortDirection": 1
			}

			if (this._Event)
			{
				this._AllBattles = []

				for (let ev of this._AllTournEvents)
				{
					filter.EventId = ev.Id
					let res = await ServerAPI.post('/battle/items', filter, false) as { List: IBattle[] }
					this._AllBattles.push(...res.List.filter(b => !!b.VideoUrl))
				}

				this._Battles = this._AllBattles
			}
			else if (this._Athlete)
			{
				filter.AthleteId = this._Athlete.Id;

				let res = await ServerAPI.post('/battle/items', filter, false) as { List: IBattle[] }
				this._Battles = this._AllBattles = res.List.filter(b => !!b.VideoUrl);
			}

			this.menuBtn.getMenu().clear()
			this.menuBtn.getMenu().addItems(this._Athlete ? this.getAthleteBattleMenuItems(this._Battles) : getBattleMenuItems(this._Battles))

			this.menuBtn.setValue(this._Battles)

			if (this._Event)
				this.menuBtn.getMenu().addItems([{Content: 'Add event', Value: 'AddEvent'}])

			this.actionsByBattle = {}
			for (let battle of this._Battles)
			{
				if (!this.actionsByBattle[battle.Id])
					this.actionsByBattle[battle.Id] = await ServerAPI.get(`/video/getAllHighlights/${battle.Id}`, false) as HighlightRow[];
			}

			this.refreshDataTable();


			let items = await ServerAPI.get(`/video/getPreviewVideos`, false) as string[];

			if (this._videoPreviewType)
			{
				let mIndex = 0;
				this._videoPreviewType.setItems(items.map((item, idx) =>
				{
					let arr = item.split("_");
					if (arr[0] == 'MatchTVNew')
						mIndex = idx;
					return {Content: arr[0] + " (" + arr[1] + "fps)", Value: item}
				}))

				this._videoPreviewType.setSelectedIndex(mIndex);
			}

			this.fynnyActionsByBattle = {};
			for (let battle of this._Battles)
				if (!this.fynnyActionsByBattle[battle.Id])
					this.fynnyActionsByBattle[battle.Id] = await ServerAPI.get(`/highlight/getHighlightFunny/${battle.Id}`, false) as FunnyItem[];

		} finally
		{
			this._topAppBar.hideWaiter()
		}
	}

	getPointTime(point: HighlightRow, battle: IBattle)
	{
		return getPointTimeFromWT((point as HighlightRow).ActionTS, battle.VideoStartTime)
	}

	getAthleteBattleMenuItems(battles: IBattle[]): IItem[]
	{
		return battles.map((b) => ({
			Value: b,
			IsCheckBox: true,
			Content: b.EventInfo + ": " + b.RedName + ' vs ' + b.BlueName
		}));
	}


	viewEvent(dtRow: any)
	{
		let battle: IBattle = null;
		let time = 0;
		if (dtRow.MMAEvent)
		{
			let hl = dtRow.MMAEvent as HighlightRow;
			battle = this._Battles.find(b => b.Id == hl.BattleId)
			time = this.getPointTime(hl, battle);
		}
		else
		{
			let f = dtRow.FunnyEvent;
			battle = this._Battles.find(b => b.Id == f.BattleId)
			time = getPointTimeFromWT(f.HighlightDate, battle.VideoStartTime)
		}

		let newUrl = `${MAIN_SERVER_URL}/video/battle_${battle.Id}.mp4`;
		if (this._videoNode.src != newUrl)
		{
			this._ViewBattle = battle;
			this._videoNode.src = newUrl
		}
		this._videoNode.currentTime = time;
	}


	setHeight(value?: number, fireEvents?: boolean)
	{
		super.setHeight(value, fireEvents);
		this._dataTable?.setHeight(value - 150);

		if (this._orderEventList)
			this._orderEventList.setHeight(value - 150 - this._videoNode.offsetHeight)
	}


	refreshDataTable()
	{
		clearTimeout(this.timeId)
		this.timeId = setTimeout(async () =>
		{
			if (!this.isLive())
				return;
			let attackTypes = this.actionTypeBtn.getValue()
			let zones = this.zoneFilterBtn.getValue();
			let points = this.pointFilterBtn.getValue();
			let answers = this.answerFilterBtn.getValue();
			let otherFilter = this.otherFilterBtn.getValue();

			let hasSuper = otherFilter.indexOf('Super') > -1;
			let onlyCutSegments = otherFilter.indexOf('СutSegments') > -1
			let hasOtherFunny = otherFilter.indexOf('OtherFunny') > -1
			let hasFavorite = otherFilter.indexOf('Favorite') > -1


			this._allActionList = [];
			for (let battle of this._Battles)
			{
				let rowsData = this.actionsByBattle[battle.Id]

				rowsData = rowsData.filter(ev =>
				{
					if (hasFavorite && ev.Favorite != 1)
						return false;

					if (otherFilter.includes('Ground') && !ev.GroundStart)
					{
						return false
					}

					if (otherFilter.includes('Grapple') && !ev.GrappleStart)
					{
						return false
					}

					if (attackTypes.indexOf(ev.Action) == -1)
						return false;

					if (ev.Zone && zones.indexOf(ev.Zone) == -1)
						return false;

					if (ev.Answer && answers.indexOf(ev.Answer) == -1)
						return false;

					if (hasSuper && !ev.HLDesc)
						return false;

					if (onlyCutSegments && !ev.SegmentFileName)
						return false;

					if (ev.ManualPoint)
						return points.indexOf(ev.ManualPoint) > -1;

					if (ev.AutoPoint)
						return points.indexOf(ev.AutoPoint) > -1;


					return true;
				})

				let funnyRows = this.fynnyActionsByBattle[battle.Id];
				if (funnyRows)
				{
					funnyRows = funnyRows.filter(f =>
					{
						if (hasOtherFunny && f.Action == 'Other')
							return true;

						return false
					})

					rowsData.push(...funnyRows as any)
				}

				if (rowsData.length)
				{

					this._allActionList.push({Action: `<span style="color: ${NP.RED_COLOR}; margin-right: 4px"> ${battle.RedName}</span> - <span style="color: ${NP.BLUE_COLOR}; margin-left: 4px"> ${battle.BlueName}</span>`} as HighlightRow)

					this._allActionList.push(...rowsData);
				}

			}

			this.renderDataTable();

		}, 500);
	}

	renderDataTable()
	{
		let rowsData = this._allActionList;

		let data = [];

		for (let f of rowsData)
			data.push(this.createRow(f))


		this._dataTable.setRows(data);

		let gongRow = this._dataTable.getRows().find((row: any) => row.FunnyEvent?.Action == 'Gong');
		if (gongRow)
			this._dataTable.setRowSelected(gongRow, false)
	}


	createRow(f: HighlightRow | FunnyItem)
	{
		let time = (f as HighlightRow).ActionTS || (f as FunnyItem).HighlightDate
		if (!time)
		{
			return {Content: f.Action, IsHeader: true}
		}

		let battle = this._Battles.find(b => b.Id == f.BattleId)
		let bName = battle.RedName.split(" ")[0] + "-" + battle.BlueName.split(" ")[0];

		if ((f as HighlightRow).ActionTS)
		{
			let m = moment(time, 'YYYY-MM-DD HH:mm:ss.S')

			let action = f.Action;
			if ((f as HighlightRow).Favorite == 1)
				action = action.toUpperCase();


			return {
				...f,
				BattleName: bName,
				Action: action,
				Position: (f as HighlightRow).GroundStart ? 'Ground' : ((f as HighlightRow).GrappleStart ? 'Grapple' : ''),
				Data: f,
				Point: (f as HighlightRow).ManualPoint || (f as HighlightRow).AutoPoint,
				WorldTime: m.toDate(),
				WorldTimeStr: m.format('HH:mm:ss'),
				MMAEvent: f,
				PrevNext: `-${f.TimeInfo.PrevSeconds} + ${f.TimeInfo.NextSeconds}`,
				CssClass: (f as HighlightRow).ActionAthleteId == battle.Red ? 'red-row' : 'blue-row'
			}
		}
		else
		{
			let row = createFunnyRow(f as FunnyItem, (f as FunnyItem).AthleteId == battle.Red ) as any
			row.BattleName = bName;
			row.Action = 'Other';
			return row;
		}
	}

	refreshVideoProgressBar()
	{
		if (this._videoProgressBar && this._ViewBattle)
		{
			this._videoProgressBar.innerHTML = '';
			let rows = this._dataTable.getSelection();
			let actionList = this._allActionList
				 .filter(row => row.BattleId == this._ViewBattle.Id)
				 .filter(row => rows.find(r => row.EventOrder == (r as unknown as HighlightRow).EventOrder));
			let duration = this._videoNode.duration;

			actionList.forEach(a =>
			{

				let hint = a.Action + " " + (a.Zone || '');
				if (a.HLDesc)
					hint += ` (${a.HLDesc})`

				this.createVideoProgressNode(duration, hint, a.ActionAthleteId == this._ViewBattle.Red, a)
			})
		}
	}

	createVideoProgressNode(fullDuration: number,
									hint: string,
									isRed: boolean,
									point: HighlightRow | FunnyItem)
	{

		let node = NP.createNode(this._videoProgressBar, 'progress-point');
		if (isRed != null)
			node.style.backgroundColor = isRed ? NP.RED_COLOR : NP.BLUE_COLOR;
		else
			node.style.backgroundColor = 'green'

		node.point = point;
		node.setAttribute('title', hint)
		this.calcVideoPointPosition(node, point, fullDuration)
		this._addEvent(node, 'click', this.onPointClick)
		this._addEvent(node, 'contextmenu', this.onPointContextMenu)
	}

	calcVideoPointPosition(node: HTMLElement, point: HighlightRow | FunnyItem, fullDuration)
	{
		let pointTime = getPointTimeFromWT((point as HighlightRow).ActionTS || (point as FunnyItem).HighlightDate,
			 this._ViewBattle.VideoStartTime);

		let segmentDuration = point.TimeInfo.NextSeconds + point.TimeInfo.PrevSeconds;
		node.style.width = (100 * segmentDuration / fullDuration) + '%'
		node.style.left = (100 * pointTime / fullDuration - 100 * point.TimeInfo.PrevSeconds / fullDuration) + '%';
		node.setAttribute('time', pointTime + '')
	}

	onPointClick(sender: object, args: EventArgs)
	{
		let node = args.Event.target as HTMLElement;
		this._videoNode.currentTime = parseInt(node.getAttribute('time'));
	}

	onPointContextMenu(sender: object, args: EventArgs)
	{
		let node = args.Event.target as HTMLElement;

		let battleEvent = (node as any).point as HighlightRow | FunnyItem;
		showSegmentMenu(battleEvent, this._videoNode, node, this._dataTable, this._ViewBattle.VideoStartTime,
			 this.createRow.bind(this),
			 this.calcVideoPointPosition.bind(this))
	}

	_onOkButtonClick()
	{
		let selectedBattles = this._Battles;
		if (!selectedBattles.length)
			return;

		(new Dialog({
			Content: new TextField({
				FloatingLabel: 'Enter name of the video',
			}),
			EvOkButtonClick: (dlg: Dialog, args: DialogCloseEventArgs) =>
			{
				let name = dlg.getContent().getValue().trim();
				if (name)
				{
					dlg.hide()
					this.doCreateVideo(name, selectedBattles)
				}
				else
					args.IsCancelClose = true
			}
		})).show()
	}

	async doCreateVideo(name: string, selectedBattles: IBattle[])
	{
		this._topAppBar.showWaiter()

		try
		{

			this.startStreamDate = new Date();
			this._streamTimeId = setTimeout(() => this.recalcDate(), 1000);
			setTimeout(() => this.recalcProgress(), 1000);
			this._timerLbl.setContent('00:00');

			let orderRows = this._orderEventList.getRows();
			let selectedEvents: (HighlightRow | FunnyItem)[] = []
			let funnyEvents: FunnyItem[] = [];
			let transitions = [];
			if (orderRows?.length)
			{
				//selectedEvents = orderRows; //;;.filter(row => row.MMAEvent || row.FunnyEvent)
				//	 .map(row => (row.MMAEvent || row.FunnyEvent) as any) as (HighlightRow | FunnyItem)[];

				let payloadBattles = [];
				let indexBattleId = null;

				orderRows.forEach((row, idx) =>
				{
					let ev = (row.MMAEvent || row.FunnyEvent || row) as any


					if ((ev as any).Transition)
					{
						transitions.push({
							CustomOrder: idx,
							Name: ev.Transition
						})
						return;
					}

					ev.CustomOrder = idx

					let battle = this._AllBattles.find(b => b.Id == ev.BattleId)
					let bRequest;
					if (indexBattleId != ev.BattleId)
					{
						bRequest = {
							battleId: ev.BattleId,
							rows: [],
							funnyList: [],
							addPreviewVideo: false,
							compressAndSort: !orderRows?.length,
							addFirstPreviewVideo: this.previewSettingsBtn.getValue().indexOf(1) > -1,
							addWallpaperToEnd: this.previewSettingsBtn.getValue().indexOf(2) > -1,
							videoStartTime: battle.VideoStartTime,
							previewType: this._videoPreviewType.getValue()
						}

						payloadBattles.push(bRequest)
					}
					else
					{
						bRequest = payloadBattles[payloadBattles.length - 1];
					}

					if ((ev as HighlightRow).EventOrder)
						bRequest.rows.push(ev)
					else
						bRequest.funnyList.push(ev)
				})

				let res = await ServerAPI.post<VideoFile>(`/video/createOrderVideo/${this._Event.Id}?name=${name}`, {
					list: payloadBattles,
					transitions: transitions
				});

				showShareDialog(res);
			}
			else
			{
				selectedEvents = this._dataTable.getSelection().filter(row => !!row.MMAEvent).map(row => row.MMAEvent as any) as HighlightRow[];
				funnyEvents = this._dataTable.getSelection().filter(row => !!row.FunnyEvent).map(row => row.FunnyEvent as any) as FunnyItem[];


				let payload = selectedBattles.map(battle =>
				{
					return {
						battleId: battle.Id,
						rows: selectedEvents.filter(ev => ev.BattleId == battle.Id),
						funnyList: funnyEvents.filter(ev => ev.BattleId == battle.Id),
						addPreviewVideo: false,
						compressAndSort: !orderRows?.length,
						addFirstPreviewVideo: this.previewSettingsBtn.getValue().indexOf(1) > -1,
						addWallpaperToEnd: this.previewSettingsBtn.getValue().indexOf(2) > -1,
						videoStartTime: battle.VideoStartTime,
						previewType: this._videoPreviewType.getValue()
					}
				});


				let res = this._Event ?
					 await ServerAPI.post<VideoFile>(`/video/createEventVideo/${this._Event.Id}?name=${name}`, payload) :
					 await ServerAPI.post<VideoFile>(`/video/createAthleteVideo/${this._Athlete.Id}?name=${name}`, payload)


				showShareDialog(res)
			}

		} finally
		{
			this.startStreamDate = null;
			this._topAppBar.hideWaiter();
		}
	}

	async recalcDate()
	{
		if (this.startStreamDate)
		{
			let t = new Date().getTime() - this.startStreamDate.getTime();
			this._timerLbl.setContent(secondsToTime(t / 1000));

			this._streamTimeId = setTimeout(() => this.recalcDate(), 800);
		}
	}

	async recalcProgress()
	{
		let info = await ServerAPI.get<{ message: string }>(`/video/getCreateHLProgress/${this._Event ? this._Event.Id : this._Athlete.Id}`)
		if (info)
		{
			this._progressLabel.setContent(' ' + info.message)
			setTimeout(() => this.recalcProgress(), 1000);
		}
		else
			this._progressLabel.setContent('')
	}
}